import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { match } from 'path-to-regexp'

import routesConstants from 'app/constants/routes.constants'
import {
  biblioteca,
  caminosBiblioteca,
  knowledgeBuilder,
  library,
  library3,
  sonidos,
  sounds,
  texasElar,
  texasSlar,
} from 'app/constants/home-content-buttons.constants'

type RoutesConstantsKeys = keyof typeof routesConstants

const getMatchingRoute = (currentPath: string) => {
  let matchingRoute = ''
  Object.entries(routesConstants).forEach(([routeName, path]) => {
    const matchFn = match(path, { decode: decodeURIComponent })
    if (matchFn(currentPath)) {
      matchingRoute = routeName
    }
  })
  return matchingRoute
}

const PageTitle = () => {
  const location = useLocation<Location>()

  useEffect(() => {
    const routeConst =
      routesConstants[
        getMatchingRoute(location.pathname) as RoutesConstantsKeys
      ]

    switch (routeConst) {
      case routesConstants.LIBRARY:
      case routesConstants.READER:
      case routesConstants.READER_ID:
        document.title = `Amplify Hub | ${library.text}`
        break
      case routesConstants.LIBRARY3:
      case routesConstants.LIBRARY_3_READER:
      case routesConstants.LIBRARY_3_READER_ID:
        document.title = `Amplify Hub | ${library3.text}`
        break
      case routesConstants.BIBLIOTECA:
      case routesConstants.SPANISH_READER:
      case routesConstants.SPANISH_READER_ID:
        document.title = `Amplify Hub | ${biblioteca.text}`
        break
      case routesConstants.CAMINOS:
      case routesConstants.CAMINOS_READER:
      case routesConstants.CAMINOS_READER_ID:
        document.title = `Amplify Hub | ${caminosBiblioteca.text}`
        break
      case routesConstants.TEXAS_ELAR:
      case routesConstants.TEXAS_ELAR_READER:
      case routesConstants.TEXAS_ELAR_READER_ID:
        document.title = `Amplify Hub | ${texasElar.text}`
        break
      case routesConstants.TEXAS_SLAR:
      case routesConstants.TEXAS_SLAR_READER:
      case routesConstants.TEXAS_SLAR_READER_ID:
        document.title = `Amplify Hub | ${texasSlar.text}`
        break
      case routesConstants.SOUNDS:
      case routesConstants.SOUNDS_ID:
        document.title = `Amplify Hub | ${sounds.text}`
        break
      case routesConstants.SONIDOS:
      case routesConstants.SONIDOS_ID:
        document.title = `Amplify Hub | ${sonidos.text}`
        break
      case routesConstants.THEATER:
      case routesConstants.THEATER_ID:
        document.title = `Amplify Hub | ${knowledgeBuilder.text}`
        break
      case routesConstants.TEACHER_GUIDE_CHAPTER:
        document.title = 'Amplify Hub | Teacher guide'
        break
      default:
        document.title = 'Amplify Hub'
        break
    }
  }, [location.pathname])

  return null
}

export default PageTitle
